import script from "./InputAttachmentPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputAttachmentPreview.vue?vue&type=script&setup=true&lang=ts"

import "./InputAttachmentPreview.vue?vue&type=style&index=0&id=62fc302a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62fc302a"]])

export default __exports__